import PropTypes from 'prop-types';

import React from 'react';

import Wrapper from './Wrapper';
import Title from './Title';
import TitleWrapper from './TitleWrapper';
import TitleIcon from './TitleIcon';
import Description from './Description';
import ModalButton from './ModalButton';
import ModalButtonWrapper from './ModalButtonWrapper';

function Modal(props) {
  return (
    <Wrapper>
      <div>
        <TitleWrapper>
          {props.icon && (
            <TitleIcon>{props.icon}</TitleIcon>
          )}

          <Title>{props.title}</Title>
        </TitleWrapper>

        <Description>{props.description}</Description>
      </div>

      <ModalButtonWrapper>
        {props.buttons.map(button => (
          <ModalButton
            key={button.text}
            onClick={button.onClick} // eslint-disable-line react/jsx-handler-names
            type={button.type}
          >
            {button.text}
          </ModalButton>
        ))}
      </ModalButtonWrapper>
    </Wrapper>
  );
}

Modal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.node,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(['dismiss', 'confirm']),
  })),
};

export default Modal;
